import React, {FC} from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import { Link } from 'react-router-dom'
import { KTSVG } from '../../../_metronic/helpers'
import { useEffect,useState } from 'react'
import { useParams } from 'react-router-dom'
import {downloadCSV} from '../customFunctions/customFunctions'
import axios from 'axios'
import { useAuth } from '../auth'
import { getBaseUrl } from '../customFunctions/customFunctions'


// const DailyReportPage: React.FC = () => (


// )
interface Submerchant{
id:string;
dba_name:string;

}
interface Report{
    total:number;
    submerchant:Submerchant;
    average:number;
    count:number;
    refund:number;
    refundVolume:number;
    chargeback:number;
    chargebackVolume:number;
    refundRatio:number;
    chargeBackRatio:number;
    chargeback_status:string;
    refund_status:string;
}
function formatMoney(amount:any){
    if(!amount){
       return "$0.00"
    }
    amount = parseFloat(amount)
    const formattedAmount = amount.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      });

  return formattedAmount
}
// function downloadCSV() {
//     // Get the table
//     var table = document.getElementById('table') as HTMLTableElement;

//     // Prepare CSV content
//     var csvContent = "data:text/csv;charset=utf-8,";

//     // Add header row
//     var headerRow = table.rows[0];
//     for (var j = 0; j < headerRow.cells.length; j++) {
//       csvContent += '"' + headerRow.cells[j].innerText + '"' + (j < headerRow.cells.length - 1 ? ',' : '\n');
//     }

//     // Add data rows
//     for (var i = 1; i < table.rows.length; i++) {
//       var dataRow = table.rows[i];
//       for (var j = 0; j < dataRow.cells.length; j++) {
//         csvContent += '"' + dataRow.cells[j].innerText + '"' + (j < dataRow.cells.length - 1 ? ',' : '\n');
//       }
//     }

//     // Create a download link
//     var encodedUri = encodeURI(csvContent);
//     var link = document.createElement("a");
//     link.setAttribute("href", encodedUri);
//     link.setAttribute("download", "report.csv");
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   }
function getSalesPercentage(value1:any,value2:any){
    if(value1 == '0.00'  && value2!= '0.00'|| value1==null){
        if(value2==null){
            return 0;
        }

        return -100;
   }
   if(value1=='0.00' && value2 == '0.00'){
    return 0;
   }
   if(value1!='0.00' && value2!='0.00' && value1!==null && value2!== null){
    return Math.ceil((parseFloat(value1) - parseFloat(value2))/(parseFloat(value1))*100)
}
return 100
}
function getPercentage(value1:any,value2:any){
    if(value1!=null && value2 !=null){
        value1 = parseFloat(value1);
        value2 = parseFloat(value2);
        if (value2 === 0) {
            // Avoid division by zero
            return '';
        }
        if(value1 === 0){
          return '';
        }
        let difference = value1 - value2
        return Math.ceil((difference / Math.abs(value2)) * 100);
    }
    // else{
    //   return 0;
    // }
}
const SubmerchantReportPage: FC = () => {
  const base = getBaseUrl()
    const { logout } = useAuth()
    const { subMerchant } = useParams();
    const reportNumbers =[0,1,2,3,4]
    const [reports, setReports] = useState<Report[]>([]);
    const [currentSubmerchant, setCurerentSubmerchant] = useState('');
    const [issue, setIssue] = useState('');

    useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await axios(base+'api/submerchant/getReport/'+ subMerchant ); // Adjust the URL accordingly
            if (response.data) {
              const data = await response.data;
              setReports(data);


            } else {
              console.error('Failed to fetch data');
            }
          } catch (error) {
            console.error('An error occurred during the fetch', error);
          }
        };

        const interceptor = axios.interceptors.response.use(
          
          response => response,
          error => {
            if (error.response && error.response.status === 401) {
              logout();
            }
            return Promise.reject(error);
          }
        );
        fetchData()
        return () => {
          axios.interceptors.response.eject(interceptor);
         
        };
}, [logout]);
  return (
    <>
      <PageTitle breadcrumbs={[]}>Submerchant Reports</PageTitle>
      <>
   <div className={`card`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>All Transactions For Submerchant ID: {reports[0]?.submerchant.dba_name}</span>
          <button className='btn btn-success btn-sm' onClick={downloadCSV}>Download Report</button>
        </h3>

      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-3 row'>
        {/* begin::Table container */}
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3' id="table">
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bold text-muted'>
              <th className='min-w-120px'>Attribute</th>
                <th className='min-w-120px'>Current Month</th>
                <th className='min-w-120px'>Month 5</th>
                <th className='min-w-120px'>Month 4</th>
                <th className='min-w-120px'>Month 3</th>
                <th className='min-w-120px'>Month 2</th>
                <th className='min-w-120px'>Month 1</th>

              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>
            {reports.length > 0 && (
           <>
           <tr>

              <td className='text-dark fw-bold text-hover-primary fs-6 px-3'>Sales</td>
                {reportNumbers.map((index)=>(
                            <td className='text-dark fw-bold text-hover-primary fs-6 px-3'>

                            {formatMoney(reports[index].total)+'('}
                            <small> {getPercentage(reports[index].total,reports[index+1].total)}% </small>
                                {reports[index].total > Math.round(reports[index + 1].total) ? (

                                    <KTSVG path='/media/icons/duotune/arrows/arr066.svg' className='svg-icon-success ms-1' />

                                                //  /media/icons/duotune/arrows/arr001.svg
                                ) : (
                                    reports[index].total < Math.round(reports[index + 1].total) && (
                                    <KTSVG path='/media/icons/duotune/arrows/arr065.svg' className='svg-icon-danger ms-1' />
                                    )
                                )}

                                {")"}
                            </td>
                ))}

              <td className='text-dark fw-bold text-hover-primary fs-6 px-3'>{formatMoney(reports[5].total)}</td>

            </tr>
            <tr>
            <td className='text-dark fw-bold text-hover-primary fs-6 px-3'>Sales Count </td>
            {reportNumbers.map((index)=>(
                            <td className='text-dark fw-bold text-hover-primary fs-6 px-3'>
                            {reports[index].count
                            +'('}
                            <small> {getPercentage(reports[index].count,reports[index+1].count)}% </small>
                                {reports[index].count > Math.round(reports[index + 1].count) ? (
                                    <KTSVG path='/media/icons/duotune/arrows/arr066.svg' className='svg-icon-success ms-1' />
                                                //  /media/icons/duotune/arrows/arr001.svg
                                ) : (
                                    reports[index].count < Math.round(reports[index + 1].count) && (
                                    <KTSVG path='/media/icons/duotune/arrows/arr065.svg' className='svg-icon-danger ms-1' />
                                    )
                                )}
                                    {")"}
                            </td>
                ))}

              <td className='text-dark fw-bold text-hover-primary fs-6 px-3'>{reports[5].count}</td>

            </tr>
            <tr>
            <td className='text-dark fw-bold text-hover-primary fs-6 px-3'>Sales Average </td>
            {reportNumbers.map((index)=>(
                            <td className='text-dark fw-bold text-hover-primary fs-6 px-3'>
                            {formatMoney(reports[index].average)    +'('}
                            <small> {getPercentage(reports[index].average,reports[index+1].average)}% </small>
                                {reports[index].average > Math.round(reports[index + 1].average) ? (
                                    <KTSVG path='/media/icons/duotune/arrows/arr066.svg' className='svg-icon-success ms-1' />
                                                //  /media/icons/duotune/arrows/arr001.svg
                                ) : (
                                    reports[index].average < Math.round(reports[index + 1].average) && (
                                    <KTSVG path='/media/icons/duotune/arrows/arr065.svg' className='svg-icon-danger ms-1' />
                                    )
                                )}
                                 {")"}
                            </td>
                ))}

              <td className='text-dark fw-bold text-hover-primary fs-6 px-3'>{formatMoney(reports[5].average)}</td>

            </tr>
            <tr>
            <td className='text-dark fw-bold text-hover-primary fs-6 px-3'>Refund Count </td>
            {reportNumbers.map((index)=>(
                            <td className='text-dark fw-bold text-hover-primary fs-6 px-3'>
                            {reports[index].refund   +'('}
                            <small> {getPercentage(reports[index].refund,reports[index+1].refund)}% </small>
                                {reports[index].refund > Math.round(reports[index + 1].refund) ? (
                                    <KTSVG path='/media/icons/duotune/arrows/arr066.svg' className='svg-icon-success ms-1' />
                                                //  /media/icons/duotune/arrows/arr001.svg
                                ) : (
                                    reports[index].refund < Math.round(reports[index + 1].refund) && (
                                    <KTSVG path='/media/icons/duotune/arrows/arr065.svg' className='svg-icon-danger ms-1' />
                                    )
                                )}
                                 {")"}
                            </td>
                ))}

              <td className='text-dark fw-bold text-hover-primary fs-6 px-3'>{reports[5].refund}</td>

            </tr>
            <tr>
            <td className='text-dark fw-bold text-hover-primary fs-6 px-3'>Refund</td>
            {reportNumbers.map((index)=>(
                            <td className='text-dark fw-bold text-hover-primary fs-6 px-3'>
                            {formatMoney(reports[index].refundVolume)   +'('}
                            <small> {getPercentage(reports[index].refundVolume,reports[index+1].refundVolume)}% </small>
                                {reports[index].refundVolume > Math.round(reports[index + 1].refundVolume)? (
                                    <KTSVG path='/media/icons/duotune/arrows/arr066.svg' className='svg-icon-success ms-1' />
                                                //  /media/icons/duotune/arrows/arr001.svg
                                ) : (
                                    reports[index].refundVolume < Math.round(reports[index + 1].refundVolume) && (
                                    <KTSVG path='/media/icons/duotune/arrows/arr065.svg' className='svg-icon-danger ms-1' />
                                    )
                                )}
                                {')'}
                            </td>
                ))}

              <td className='text-dark fw-bold text-hover-primary fs-6 px-3'>{formatMoney(reports[5].refundVolume)}</td>

            </tr>
            <tr>

                <td className='text-dark fw-bold text-hover-primary fs-6 px-3'>Chargeback </td>
                {reportNumbers.map((index)=>(
                            <td className='text-dark fw-bold text-hover-primary fs-6 px-3'>
                            {formatMoney(reports[index].chargebackVolume)   +'('}
                            <small> {getPercentage(reports[index].chargebackVolume,reports[index+1].chargebackVolume)}% </small>
                                {reports[index].chargebackVolume > Math.round(reports[index + 1].chargebackVolume)? (
                                    <KTSVG path='/media/icons/duotune/arrows/arr066.svg' className='svg-icon-success ms-1' />
                                                //  /media/icons/duotune/arrows/arr001.svg
                                ) : (
                                    reports[index].chargebackVolume < Math.round(reports[index + 1].chargebackVolume)&& (
                                    <KTSVG path='/media/icons/duotune/arrows/arr065.svg' className='svg-icon-danger ms-1' />
                                    )
                                )}
                                {')'}
                            </td>
                ))}

              <td className='text-dark fw-bold text-hover-primary fs-6 px-3'>{formatMoney(reports[5].chargebackVolume)}</td>

            </tr>
            <tr>

                <td className='text-dark fw-bold text-hover-primary fs-6'>Chargeback Count </td>
                {reportNumbers.map((index)=>(
                            <td className='text-dark fw-bold text-hover-primary px-3 fs-6'>
                            {reports[index].chargeback   +'('}
                            <small> {getPercentage(reports[index].chargeback,reports[index+1].chargeback)}% </small>
                                {reports[index].chargeback > Math.round(reports[index + 1].chargeback) ? (
                                    <KTSVG path='/media/icons/duotune/arrows/arr066.svg' className='svg-icon-success ms-1' />
                                                //  /media/icons/duotune/arrows/arr001.svg
                                ) : (
                                    reports[index].chargeback < Math.round(reports[index + 1].chargeback) && (
                                    <KTSVG path='/media/icons/duotune/arrows/arr065.svg' className='svg-icon-danger ms-1' />
                                    )
                                )}
                                {')'}
                            </td>
                ))}

              <td className='text-dark fw-bold text-hover-primary px-3 fs-6'>{reports[5].chargeback}</td>

             </tr>
             <tr>
             <td className='text-dark fw-bold text-hover-primary fs-6 px-3' >Refund %</td>
                {reportNumbers.map((index)=>(
                        <td className={`text-dark fw-bold text-hover-primary fs-6 ${reports[index].refund_status === 'Danger' ? 'danger'
                         : reports[index].refund_status==='Warning' ?  'warning':''}`}>
                        {reports[index].refundRatio  +'% ('}
                        <small> {getPercentage(reports[index].refundRatio,reports[index+1].refundRatio)}% </small>
                            {reports[index].refundRatio > Math.round(reports[index + 1].refundRatio) ? (
                                <KTSVG path='/media/icons/duotune/arrows/arr066.svg' className='svg-icon-success ms-1' />
                                            //  /media/icons/duotune/arrows/arr001.svg
                            ) : (
                                reports[index].refundRatio < Math.round(reports[index + 1].refundRatio) && (
                                <KTSVG path='/media/icons/duotune/arrows/arr065.svg' className='svg-icon-danger ms-1' />
                                )
                            )}
                            {')'}
                        </td>
                ))}
                <td className='text-dark fw-bold text-hover-primary fs-6 px-3'>{reports[5].refundRatio }%</td>
             </tr>
             <tr>
             <td className='text-dark fw-bold text-hover-primary fs-6 px-3'>Chargeback %</td>
                {reportNumbers.map((index)=>(
                            <td className={`text-dark fw-bold text-hover-primary fs-6 ${reports[index].chargeback_status === 'Danger' ? 'danger'
                                             : reports[index].chargeback_status==='Warning' ?  'warning':''}`}>
                        {reports[index].chargeBackRatio    +'% ('}
                        <small> {getPercentage(reports[index].chargeBackRatio ,reports[index+1].chargeBackRatio )}% </small>
                            {reports[index].chargeBackRatio   > Math.round(reports[index + 1].chargeBackRatio)  ? (
                                <KTSVG path='/media/icons/duotune/arrows/arr066.svg' className='svg-icon-success ms-1' />
                                            //  /media/icons/duotune/arrows/arr001.svg
                            ) : (
                                reports[index].chargeBackRatio   < Math.round(reports[index + 1].chargeBackRatio) && (
                                <KTSVG path='/media/icons/duotune/arrows/arr065.svg' className='svg-icon-danger ms-1' />
                                )
                            )}
                            {')'}
                        </td>
                ))}
                <td className='text-dark fw-bold text-hover-primary fs-6'>{reports[5].chargeBackRatio  }%</td>
             </tr>
             </>
 )}

            </tbody>
            {/* end::Table body */}
          </table>

          {/* end::Table */}
        </div>

        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>
    </>
    </>
  )
}

export default SubmerchantReportPage
